import { Injectable } from '@angular/core';
import { DataTaskService } from '@app/core/services/data-task.service';

@Injectable({
    providedIn: 'root',
})
export class TimeRegisterService {
    constructor(private datatask: DataTaskService) {}

    /**
     * Retrieves list of labourers for time registrations.
     *
     * @datatask 121
     * @datataskName sp_ws_p2_labour_list_tr
     * @returns promise containing list of labourers.
     */
    public async getLaborersTr(): Promise<LabourerTrItem[]> {
        return this.datatask.Post(121);
    }
}

export interface LabourerTrItem {
    item_id: string | number;
    item_name: string;
    item_state: string;
    item_parms: string;
    orderby: string;
    item_glyphicon: string;
    item_glyphicon_color: string;
}
